function createSections(ListActivities, start, end) {
    let slicedItems = ListActivities.slice(start, end);
    return slicedItems;
}

const sliceItems = (ListActivities, rowsPerPage, currentPage) => {
    currentPage--;

    let start = rowsPerPage * currentPage;
    let end = start + rowsPerPage;

    return createSections(ListActivities, start, end)
}

export default sliceItems


